export default __webpack_public_path__ + "static/media/white-logo.6e18c830.png";